import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RecipeService from "../../../services/OrderingServices/RecipeService";
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Spinner,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const RecipeDetail = () => {
  const [open, setOpen] = useState("");

  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      const response = await RecipeService.getDetail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center text-danger mt-4">
        Failed to load recipe details
      </div>
    );
  }
  const breadcrumbItems = [
    { title: "Back To List", link: "/receipe-management" },
  ];

  const toggle = (id) => {
    setOpen(open === id ? "" : id);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Recipe"
          title="Recipe Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Row>
        {/* Recipe Info */}
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <CardBody>
              <h3 className="h4 mb-3">{data.productName}</h3>
              <p className="text-muted">
                <strong>Description:</strong>{" "}
                {data.description || "No description available"}
              </p>
            </CardBody>
          </Card>
        </Col>

        {/* Ingredients Accordion */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="border-0">
              <h5 className="mb-0">Ingredients</h5>
            </CardHeader>
            <CardBody>
              {data.recipeDetails && data.recipeDetails.length > 0 ? (
                <Accordion open={open} toggle={toggle}>
                  {data.recipeDetails.map((item, index) => (
                    <AccordionItem key={index}>
                      <AccordionHeader targetId={String(index)}>
                        <div className="d-flex justify-content-between w-100">
                          <span>
                            {index + 1}. {item.ingredientName}
                          </span>
                          <span className="text-muted">{item.quantity}</span>
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId={String(index)}>
                        <p className="mb-2">
                          <strong>Quantity:</strong> {item.quantity}
                        </p>
                        <p className="mb-0">
                          <strong>Description:</strong>{" "}
                          {item.description || "No extra details"}
                        </p>
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              ) : (
                <p className="text-muted fst-italic">No ingredients found.</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RecipeDetail;
